import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import TrengoCredentialsStore from "../../../stores/credentials/trengo-credentials-store";

interface IIntegrationProps {
    credentialsStore: TrengoCredentialsStore,
    vGroup: IValidationGroup,
}

const TrengoCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Api Key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Channel ID' required key='tickets_channel_id' note='The channel ID can be found on the URL on Settings > Channels > Custom > ID on the channel selected'>
                <Input
                    value={credentialsStore.tickets_channel_id}
                    onChange={v => credentialsStore.tickets_channel_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Email channel ID' required key='email_channel_id' note='The email channel ID can be found on the URL on Settings > Channels > Email > ID on the email selected'>
                <Input
                    value={credentialsStore.email_channel_id}
                    onChange={v => credentialsStore.email_channel_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default TrengoCredentials;
